// Per-participant color palette for team cook sessions.
//
// Every cook_session_participants row carries a color_tag picked by the
// BEFORE-INSERT trigger in migration 0173. Client code reads the tag and
// hands it to paletteEntry() to get the actual tokens — no per-render
// randomness, no client-side picking.
//
// Order matters. The DB trigger walks this same list and picks the
// lowest-position unused key for each new participant, so first
// participant takes 'cobalt', second takes 'rose', and so on.

export const PARTICIPANT_PALETTE = [
  "cobalt",
  "rose",
  "olive",
  "amber",
  "plum",
  "teal",
  "rust",
  "slate",
];

const HEX = {
  cobalt: "#3D6BB8",
  rose:   "#C25A7A",
  olive:  "#7A8B4A",
  amber:  "#D4A637",
  plum:   "#7A4E2D",
  teal:   "#2F8F83",
  rust:   "#A8553A",
  slate:  "#5A6B7A",
};

function withAlpha(hex, alpha) {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

const LABEL = {
  cobalt: "Cobalt",
  rose:   "Rose",
  olive:  "Olive",
  amber:  "Amber",
  plum:   "Plum",
  teal:   "Teal",
  rust:   "Rust",
  slate:  "Slate",
};

// paletteEntry(tag) → { bg, ring, ink, label }
//   bg   — low-alpha row background tint
//   ring — solid hex used for avatar rings + left-border accents
//   ink  — high-contrast text on the bg tint
//   label — human-readable name (debugging surfaces, accessibility)
//
// Unknown tags (e.g. the 'extra_<uuid>' fallback when palette is
// exhausted, or stale legacy values) collapse to a neutral slate tone
// rather than throwing.
export function paletteEntry(tag) {
  const key = HEX[tag] ? tag : "slate";
  const hex = HEX[key];
  return {
    key,
    bg:    withAlpha(hex, 0.12),
    bgSolid: hex,
    ring:  hex,
    ink:   "#1E1E1E",
    label: LABEL[key] || "Slate",
  };
}
